import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MotifAccordion, MotifAccordionContent, MotifAccordionTrigger } from '../../../../components/accordion/accordion.module';
import { ReactComponent as ContentIcClose24px } from '../../../../assets/icons/navigation/ic_close_24px.svg';
import { ReactComponent as ContentIcFile24px } from '../../../../assets/icons/action/ic_description_24px.svg';
import { ReactComponent as ContentIcLink24px } from '../../../../assets/icons/action/ic_language_24px.svg';

const defaultIcons = {
  close: <ContentIcClose24px />,
  file: <ContentIcFile24px />,
  link: <ContentIcLink24px />
};

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 * @prop {{close: React.ReactNode, file: React.ReactNode, link: React.ReactNode}} [icons]
 * @prop {string} [title]
 * @prop {string} [url]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifMetadata = (props) => {
  const {
    children,
    className = '',
    icons: userIcons,
    title = '',
    url = '',
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const classes = classNames({
    'motif-metadata': true,
    [className]: true
  });

  return (
    <MotifAccordion
      useChevronIcon={true}
      className={classes}
      data-motif-metadata
      {...other}
    >
      <button
          className="motif-close-metadata-button"
          data-testid="close-metadata"
          aria-label={`click here to remove ${title || url}`}
          title="close-metadata-button"
        >
          {icons.close}
      </button>
      <MotifAccordionTrigger className="motif-metadata-trigger">
        {url
        ? (
          icons.link
        )
        : (
          icons.file
        )
        }
        {title || url}
      </MotifAccordionTrigger>
      <MotifAccordionContent className="motif-metadata-content">
        {children}
      </MotifAccordionContent>
    </MotifAccordion>
  );
};

MotifMetadata.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icons: PropTypes.shape({
    close: PropTypes.node,
    file: PropTypes.node,
    link: PropTypes.node
  }),
  title: PropTypes.string,
  url: PropTypes.string
};

export { MotifMetadata };
